export const flexStyle = {
    display: 'flex',
}
